import { createStyles } from '@mantine/core';

export const ICON_SIZE = 52;

export const useStyles = createStyles((theme) => ({
  card: {
    backgroundColor: theme.white,
    borderRadius: theme.other.spacing._12,
    overflow: 'hidden',
    marginBottom: theme.other.spacing._32,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._16,
    width: '100%',
    padding: theme.other.spacing._16,
    textAlign: 'left',

    [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
      padding: theme.other.spacing._24,
    },
  },
  iconContainer: {
    position: 'relative',
    flexShrink: 0,
    width: ICON_SIZE,
    height: ICON_SIZE,
  },
  icon: {
    objectFit: 'contain',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-around',
    gap: theme.other.spacing._8,

    [`@media (min-width: ${theme.breakpoints.sm}px)`]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
  textContent: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._4,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
    flexWrap: 'wrap',
  },
  learnMore: {
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  availableTag: {
    textTransform: 'uppercase',
    backgroundColor: theme.colors.blue[3],
    padding: `${theme.other.spacing._2}px ${theme.other.spacing._6}px`,
    borderRadius: theme.other.spacing._12,
  },
  divider: {
    borderTop: `1px solid ${theme.colors.gray2[0]}`,
  },
}));
